// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1DLpM","col":"CardReaderDesc_col__2lieK","label":"CardReaderDesc_label__2Qcd4"};